import moment from 'moment';

export function isFilterValueSet(value) {
	if (value === null || value === undefined) return false;
	if (Array.isArray(value)) return value.length > 0;
	if (moment.isMoment(value)) return value.isValid();
	if (value instanceof Date) return !Number.isNaN(value.getTime());
	if (typeof value === 'object') {
		if ('value' in value) {
			return (
				value.value !== null && value.value !== undefined && value.value !== ''
			);
		}
		return Object.keys(value).length > 0 && Object.values(value).some(v => !!v);
	}
	if (typeof value === 'string') return value.trim() !== '';
	return !!value;
}

function getFilterClearValue(filter) {
	if (filter.clearValue !== undefined) return filter.clearValue;
	if (filter.type === 'compensation') return null;
	if (filter.type === 'text' || filter.type === 'search') return '';
	if (Array.isArray(filter.value)) return [];
	return null;
}

export function buildAppliedFilterItems(filters = []) {
	return filters
		.filter(f => isFilterValueSet(f.value))
		.map(f => ({
			label: f.label,
			onRemove: () => f.onChange(getFilterClearValue(f))
		}));
}
